import { Button } from 'components/universal/button';
import { useTopic } from 'hooks/useTopic';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCanSubmitAnswer, selectIsQuestionAnswered, selectIsTaskSuccess, selectTaskAnswerById } from 'store/topic/topicSlice';
import cls from './topic-status-with-button.module.scss';
import { TopicStatus } from '../topic-status';
import { Task } from 'types/elearning';

interface IProps {
    task: Task; 
    type: string;
}

export const TopicStatusWithButtonSingle: FC<IProps> = ({ task, type }) => {
    const { t } = useTranslation('', {
        keyPrefix: 'components.topicStatusWithButton',
    });
    const { handleTryAgainSingleTask, checkAnswersSingle } = useTopic();

    const isAnswered = useSelector(selectIsQuestionAnswered(task.id));
    const isTaskSuccess = useSelector(selectIsTaskSuccess(task.id));
    const taskAnswer = useSelector(selectTaskAnswerById(task.id));
    const canSubmitAnswer = useSelector(selectCanSubmitAnswer);

    let isDisabled = isAnswered;
    
    if (task?.type === 'challenge_match_text_with_images' || task?.type === 'challenge_match_image_with_description') {
        isDisabled = canSubmitAnswer;
    }
    
    return (
        <Fragment>
            {isTaskSuccess ? (
                <TopicStatus
                    title={taskAnswer?.isDone ? t('titleDone') : t('titleNotDone')}
                    buttonText={t('buttonReset')}
                    obtainedPoints={taskAnswer?.points?.obtained}
                    maxScore={taskAnswer?.points?.total}
                    isSuccess={taskAnswer?.isDone}
                    onSubmit={() => handleTryAgainSingleTask(task)}
                    description={taskAnswer?.descriptionAnswer}
                    taskType={task?.type}
                />
            ) : (
                <Button 
                    className={cls.button}
                    onClick={() => checkAnswersSingle(task.id, type)}
                    disabled={!isDisabled}
                >
                    {t('checkAnswerButtonText')}
                </Button>
            )}
        </Fragment>
    );
};
